import { useEffect, useState } from 'react';
var useSystemThemeDetector = function () {
    var getCurrentTheme = function () {
        if (typeof window === 'undefined') {
            return false;
        }
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    };
    var _a = useState(getCurrentTheme()), isDarkTheme = _a[0], setIsDarkTheme = _a[1];
    useEffect(function () {
        if (typeof window !== 'undefined') {
            var darkThemeMq_1 = window.matchMedia("(prefers-color-scheme: dark)");
            darkThemeMq_1.addListener(mqListener);
            return function () { return darkThemeMq_1.removeListener(mqListener); };
        }
        return function () { };
    }, []);
    if (typeof window === 'undefined') {
        return false;
    }
    var mqListener = (function (event) {
        setIsDarkTheme(event.matches);
    });
    return isDarkTheme;
};
export default useSystemThemeDetector;
